import React from "react";
import { facilitiesData } from "./FacilitiesData";
import "../../css/components/standardPage.css";
import "../../css/company/facilities.css";

export const Facilities = () => {
  return (
    <div className="standard-page">
      {/* Hero Section */}
      <div
        className="page-hero"
        style={{
          backgroundImage: facilitiesData.content[0]?.href ? `url(${facilitiesData.content[0].href})` : undefined,
        }}
      >
        <div className="hero-overlay"></div>
        
        {/* Main Title */}
        <h1 className="page-title">{facilitiesData.title}</h1>

        {/* Hero Cards - smaller cards with key points */}
        <div className="hero-cards-container">
          {facilitiesData.heroCards.map((card, index) => (
            <div key={index} className="hero-card">
              <h3 className="hero-card-title">{card.title}</h3>
              <p className="hero-card-description">{card.description}</p>
          </div>
        ))}
        </div>
      </div>

      {/* Content Sections */}
      <div className="content-sections">
        {facilitiesData.content.slice(1).map((section, index) => {
          return (
            <div
              key={index}
              className="content-section"
              style={{
                backgroundImage: section.href ? `url(${section.href})` : undefined,
              }}
            >
              <div className="section-overlay"></div>
              {section.title && <h2 className="section-title-overlay">{section.title}</h2>}
              <div className={`section-cards-container ${section.cards.length === 2 ? 'two-cards' : section.cards.length === 3 ? 'three-cards' : section.cards.length === 4 ? 'four-cards' : ''}`}>
                {section.cards.map((card, cardIndex) => (
                  <div key={cardIndex} className="section-card">
                    {card.title && <h3 className="section-card-title">{card.title}</h3>}
                    <p className="section-card-description">{card.description}</p>
          </div>
        ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
